import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from '../Header/Button';
import HelpIcon from '../../assets/images/help.svg';

class HelpButtonModal extends Component {
  state = {
    isOpen: false,
  };

  toggleModal = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { isOpen } = this.state;
    const { children } = this.props;
    return (
      <>
        <Button
          title="Help"
          onClick={this.toggleModal}
          className="help-btn"
        >
          <span className="help-icon">
            <img src={HelpIcon} className="help-icon-img" alt="" />
          </span>
        </Button>
        <Dialog
          open={isOpen}
          onClose={this.toggleModal}
          fullWidth
          maxWidth="md"
        >
          <DialogContent>
            <IconButton
              size="small"
              label="Close"
              onClick={this.toggleModal}
              classes={{ root: 'help-modal-close-btn' }}
            >
              <CloseIcon />
            </IconButton>
            <section className="modal modal--information">
              <div className="modal-content">
                <div className="container-text">
                  {children}
                </div>
              </div>
            </section>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}

export default HelpButtonModal;
